/* eslint-disable @typescript-eslint/no-explicit-any */
import { UseQueryOptions } from 'react-query';
import { useList } from '../../../api/react-query';

interface Props {
  id: string;
  options?:
    | Omit<UseQueryOptions<any, unknown, any, object[]>, 'queryKey' | 'queryFn'>
    | undefined;
}

const useViewOne = ({ id, options }: Props) => {
  const { data, isLoading, isFetching, isRefetching } = useList(
    `letter-generation/employees/letter-requests/${id}`,
    {},
    options,
  );

  return {
    data: data?.data?.data,
    isLoading: isLoading || isFetching || isRefetching,
  };
};

export { useViewOne };
